import { HighlightPipe } from './highlight.pipe';

export const HIGHLIGHT_PIPE_DECLARATIONS = [HighlightPipe];

export * from './highlight.pipe';
